import { render, staticRenderFns } from "./AttributesListsServerTable.vue?vue&type=template&id=1d11e8ba"
import script from "./AttributesListsServerTable.vue?vue&type=script&lang=js"
export * from "./AttributesListsServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports